import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'

import { GenericEvents } from 'product/types/GenericEvents'
import type { ProductLocations } from 'product/types/ProductLocations'

export function sendSwipeImagesEvent({
	colorId,
	productId,
	count,
	location,
	direction,
}: {
	colorId: string
	productId: string
	count: number
	location: ProductLocations
	direction: 'left' | 'right'
}) {
	sendGenericEvent(`${GenericEvents.SWIPE_IMAGES_PREFIX}${count}`, {
		color: colorId,
		product_id: productId,
		location,
		direction,
	})
}
